
<div class="container wow fadeIn top-buffer">
    <div class="container my-5">
        <div class="row justify-content-center">
            <div class="col-lg-5">
                <card type="secondary" shadow header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5"
                    class="border-0">
                        <div class="text-muted text-center mb-3">
                            <small>Sign in with</small>
                        </div>
                        <form role="form">
                            <input  class="mb-3 form-control alternative" placeholder="Email/Mobile Number  " v-model="username" addon-left-icon="ni ni-email-83" />
                            <input class="mb-3 form-control alternative" type="password" v-model="password" placeholder="Password"
                                addon-left-icon="ni ni-lock-circle-open">
                            <div class="text-center">
                                <base-button type="primary" @click="login" class="btn btn-block">Sign In</base-button>
                            </div>
                        </form>
                        <div class="text-center text-muted mb-4 my-3">
                            <small>Or sign in with Google</small>
                            <br />
                            <base-button @click="LoginGoogle" type="danger"  class="my-4">
                            Google
                        </base-button>
                        </div>
                </card>
                <div class="row mt-3">
                    <div class="col-6">
                        <a href="/forgotpassword" class="text-light">
                            <small>Forgot password?</small>
                        </a>
                    </div>
                    <div class="col-6 text-right">
                        <a href="https://identity.umbai.co.za/account/register" class="text-light">
                            <small>Create new account</small>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="vld-parent">
        <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>
    </div>
</div>